// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3MNpw","consentsList":"PatientConsents_consentsList__2dtYm","consentsListEmpty":"PatientConsents_consentsListEmpty__1nUoG"};